import {
  PlaycastMessage,
  PlaycastMessageRemoteSendFunctionCommand,
  // PlaycastMessageRemoteChangeCaptureMode,
  // PlaycastMessageRemoteGeneratePlayerLink,
  // PlaycastMessageRemoteKickPlayer,
  // PlaycastMessageRemoteChangeDefaultStream,
  // PlaycastMessageRemoteSetAllowedGamepadInput,
  // PlaycastMessageRemoteSetAllowedKeyboardInput,
  // PlaycastMessageRemoteSetAllowedMouseInput,
  // PlaycastMessageRemoteStartStream,
  // PlaycastMessageRemoteStopStream,
  // PlaycastMessageRemoteSetAudioEnabled,
  // PlaycastMessageRemoteSetStreamTitle,
  // PlaycastMessageRemoteSetMicrophone,
  // PlaycastMessageRemoteSetMicrophoneEnabled,
  // PlaycastMessageRemoteChangeDisplay,
  // PlaycastMessageRemoteEnableSurfing,
  // PlaycastMessageRemoteShowQrCode,
  // PlaycastMessageRemoteShowVideo,
  // PlaycastMessageRemoteSetStaticImage,
  // PlaycastMessageRemoteSetQrCodeParameters,
  // PlaycastMessageRemoteFetchAudioSources,
  // PlaycastMessageRemoteSetDesktopAudioSource,
  // PlaycastMessageRemoteSetHostQrCodeParameters,
  // PlaycastMessagingRemoteSetGamepadSharing,
} from '../types';
import { formatMessage } from './_util/formatMessage';

const target = 'remote';

export const sendFunctionCommand = (
  functionName: string,
  functionArgs: any[],
  userAuth?: string,
): PlaycastMessage<PlaycastMessageRemoteSendFunctionCommand> => {
  const hostId = 'remoteControl';
  const messageSource = 'host';
  const message: PlaycastMessageRemoteSendFunctionCommand = {
    target,
    action: 'sendFunctionCommand',
    isReply: false,
    message: {
      functionName,
      functionArgs,
    },
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteSendFunctionCommand>;
};

// export const startStream = (userAuth?: string): PlaycastMessage<PlaycastMessageRemoteStartStream> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteStartStream = {
//     target,
//     action: 'startStream',
//     isReply: false,
//     message: {},
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteStartStream>;
// };

// export const stopStream = (userAuth?: string): PlaycastMessage<PlaycastMessageRemoteStopStream> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteStopStream = {
//     target,
//     action: 'stopStream',
//     isReply: false,
//     message: {},
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteStopStream>;
// };

// export const setStreamTitle = (title: string, userAuth?: string): PlaycastMessage<PlaycastMessageRemoteSetStreamTitle> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteSetStreamTitle = {
//     target,
//     action: 'setStreamTitle',
//     isReply: false,
//     message: {
//       title,
//     },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteSetStreamTitle>;
// };

// export const generatePlayerLink = (userAuth?: string): PlaycastMessage<PlaycastMessageRemoteGeneratePlayerLink> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteGeneratePlayerLink = {
//     target,
//     action: 'generatePlayerLink',
//     isReply: false,
//     message: {},
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteGeneratePlayerLink>;
// };

// export const setAudioEnabled = (enabled: boolean, userAuth?: string): PlaycastMessage<PlaycastMessageRemoteSetAudioEnabled> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteSetAudioEnabled = {
//     target,
//     action: 'setAudioEnabled',
//     isReply: false,
//     message: {
//       enabled,
//     },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteSetAudioEnabled>;
// };

// export const setMicrophone = (deviceId: string, userAuth?: string): PlaycastMessage<PlaycastMessageRemoteSetMicrophone> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteSetMicrophone = {
//     target,
//     action: 'setMicrophone',
//     isReply: false,
//     message: {
//       deviceId,
//     },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteSetMicrophone>;
// };

// export const setMicrophoneEnabled = (enabled: boolean, userAuth?: string): PlaycastMessage<PlaycastMessageRemoteSetMicrophoneEnabled> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteSetMicrophoneEnabled = {
//     target,
//     action: 'setMicrophoneEnabled',
//     isReply: false,
//     message: {
//       enabled,
//     },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteSetMicrophoneEnabled>;
// };

// export const changeCaptureMode = (mode: CaptureMethod, userAuth?: string): PlaycastMessage<PlaycastMessageRemoteChangeCaptureMode> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteChangeCaptureMode = {
//     target,
//     action: 'changeCaptureMode',
//     isReply: false,
//     message: { mode },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteChangeCaptureMode>;
// };

// export const kickPlayer = (playerId: string, userAuth?: string): PlaycastMessage<PlaycastMessageRemoteKickPlayer> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteKickPlayer = {
//     target,
//     action: 'kickPlayer',
//     isReply: false,
//     message: { playerId },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteKickPlayer>;
// };

// export const setAllowedGamepadInput = (
//   allowed: boolean,
//   playerId: string,
//   userAuth?: string,
// ): PlaycastMessage<PlaycastMessageRemoteSetAllowedGamepadInput> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteSetAllowedGamepadInput = {
//     target,
//     action: 'setAllowedGamepadInput',
//     isReply: false,
//     message: {
//       allowed,
//       playerId,
//     },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteSetAllowedGamepadInput>;
// };

// export const setAllowedKeyboardInput = (
//   allowed: boolean,
//   playerId: string,
//   userAuth?: string,
// ): PlaycastMessage<PlaycastMessageRemoteSetAllowedKeyboardInput> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteSetAllowedKeyboardInput = {
//     target,
//     action: 'setAllowedKeyboardInput',
//     isReply: false,
//     message: {
//       allowed,
//       playerId,
//     },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteSetAllowedKeyboardInput>;
// };

// export const setAllowedMouseInput = (
//   allowed: boolean,
//   playerId: string,
//   userAuth?: string,
// ): PlaycastMessage<PlaycastMessageRemoteSetAllowedMouseInput> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteSetAllowedMouseInput = {
//     target,
//     action: 'setAllowedMouseInput',
//     isReply: false,
//     message: {
//       allowed,
//       playerId,
//     },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteSetAllowedMouseInput>;
// };

// export const changeDefaultStream = (streamId: string, userAuth?: string): PlaycastMessage<PlaycastMessageRemoteChangeDefaultStream> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteChangeDefaultStream = {
//     target,
//     action: 'changeDefaultStream',
//     isReply: false,
//     message: { streamId },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteChangeDefaultStream>;
// };

// export const changeDisplay = (displayId: number, userAuth?: string): PlaycastMessage<PlaycastMessageRemoteChangeDisplay> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteChangeDisplay = {
//     target,
//     action: 'changeDisplay',
//     isReply: false,
//     message: { displayId },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteChangeDisplay>;
// };

// export const enableSurfing = (enabled: boolean, userAuth?: string): PlaycastMessage<PlaycastMessageRemoteEnableSurfing> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteEnableSurfing = {
//     target,
//     action: 'enableSurfing',
//     isReply: false,
//     message: {
//       enabled,
//     },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteEnableSurfing>;
// };

// export const showVideo = (show: boolean, playerId: string, userAuth?: string): PlaycastMessage<PlaycastMessageRemoteShowVideo> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteShowVideo = {
//     target,
//     action: 'showVideo',
//     isReply: false,
//     message: {
//       show,
//       playerId,
//     },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteShowVideo>;
// };

// export const showQrCode = (show: boolean, playerId: string, userAuth?: string): PlaycastMessage<PlaycastMessageRemoteShowQrCode> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteShowQrCode = {
//     target,
//     action: 'showQrCode',
//     isReply: false,
//     message: {
//       show,
//       playerId,
//     },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteShowQrCode>;
// };

// export const setStaticImage = (
//   image: string,
//   playerId: string,
//   userAuth?: string,
// ): PlaycastMessage<PlaycastMessageRemoteSetStaticImage> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteSetStaticImage = {
//     target,
//     action: 'setStaticImage',
//     isReply: false,
//     message: {
//       image,
//       playerId,
//     },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteSetStaticImage>;
// };

// export const setQrCodeParameters = (
//   qrCodeParameters: PlayerQrCodeParameters,
//   userAuth?: string,
// ): PlaycastMessage<PlaycastMessageRemoteSetQrCodeParameters> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteSetQrCodeParameters = {
//     target,
//     action: 'setQrCodeParameters',
//     isReply: false,
//     message: {
//       qrCodeParameters,
//     },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteSetQrCodeParameters>;
// };

// export const setHostQrCodeParameters = (
//   hostSettings: HostQrCodeParameters,
//   userAuth?: string,
// ): PlaycastMessage<PlaycastMessageRemoteSetHostQrCodeParameters> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteSetHostQrCodeParameters = {
//     target,
//     action: 'setHostQrCodeParameters',
//     isReply: false,
//     message: {
//       hostSettings,
//     },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteSetHostQrCodeParameters>;
// };

// export const fetchAudioSources = (userAuth?: string): PlaycastMessage<PlaycastMessageRemoteFetchAudioSources> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteFetchAudioSources = {
//     target,
//     action: 'fetchAudioSources',
//     isReply: false,
//     message: {},
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteFetchAudioSources>;
// };

// export const setDesktopAudioSource = (
//   sourceId: string,
//   playerId: string,
//   userAuth?: string,
// ): PlaycastMessage<PlaycastMessageRemoteSetDesktopAudioSource> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageRemoteSetDesktopAudioSource = {
//     target,
//     action: 'setDesktopAudioSource',
//     isReply: false,
//     message: {
//       sourceId,
//       playerId,
//     },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRemoteSetDesktopAudioSource>;
// };

// export const setGamepadSharing = (enabled: boolean, userAuth?: string): PlaycastMessage<PlaycastMessagingRemoteSetGamepadSharing> => {
//   const hostId = 'remoteControl';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessagingRemoteSetGamepadSharing = {
//     target,
//     action: 'setGamepadSharing',
//     isReply: false,
//     message: {
//       enabled,
//     },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessagingRemoteSetGamepadSharing>;
// };
